import React from "react";
import css from "./style.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import api from "./api";
import Adventure from "./adventure";
import Loading from "components/shared/loading";
import AdBox from "components/adBox";
import Button from "components/shared/button";
import store from "utils/store";
import { push } from "react-router-redux";
import analytics from "utils/analytics";

const NoAdventures = props => {
  return (
    <div className={css.noAdventures}>
      <h4 className={css.title}>No adventures here...</h4>
      <p>
        An adventure is a collection of stories. <br />
        With an adventure, you can organize your stories and share them with
        whoever you want.
        <Button onClick={props.onClick} primary>
          New Adventure
        </Button>
      </p>
    </div>
  );
};

class AdventuresSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }
  loadAdventures() {
    this.setState({ loading: true });
    api.getAdventures(this.props.account).then(adventures => {
      this.setState({ loading: false });
      this.setState({ adventures });
    });
  }
  componentDidMount() {
    analytics.track("view_adventures");
    this.loadAdventures();
  }
  renderAdventures() {
    if (this.props.adventures.length > 0) {
      return (
        <div className={css.adventures_container}>
          {this.props.adventures.map(a => (
            <Adventure key={a.id} {...a} />
          ))}
        </div>
      );
    } else {
      return <NoAdventures onClick={this.newAdventure} />;
    }
  }
  newAdventure = () => {
    store.dispatch(
      push({
        pathname: "/a/" + this.props.match.params.id,
        state: {
          adventureDialog: true
        }
      })
    );
  };
  render() {
    return (
      <div>
        <div className={css.head}>
          <h3>Adventures</h3>
          {this.props.adventures.length > 0 && (
            <Button
              className={css.newAdventureButton}
              onClick={this.newAdventure}
            >
              New Adventure
            </Button>
          )}
        </div>
        {this.state.loading && <Loading />}
        {!this.state.loading && this.renderAdventures()}
        <AdBox width="100%" height="160px" />
      </div>
    );
  }
}

const mapStateToProps = function(state, props) {
  let account = state.accounts[props.match.params.id];
  let adventures = state.adventures.filter(a => a.account.id === account.id);
  return { account, adventures };
};

export default connect(mapStateToProps)(withRouter(AdventuresSection));



// WEBPACK FOOTER //
// ./src/components/account_page/adventures/index.js